import './style.css'
import { syncLocale } from './i18n'
import {
  mountWidgetMode,
  type RootWidgetMode,
} from './composables/widgetModeHandlers'

export interface OnwardSearcherConfig {
  mode?: RootWidgetMode
  stepsTarget?: string | Element
  domain?: string
  allowStripe?: boolean
}

class OnwardSearcher {
  mount(id: string | Element, config?: OnwardSearcherConfig) {
    syncLocale()

    const target = typeof id === 'string' ? document.querySelector(id) : id
    if (!target) {
      throw new Error(`Target element not found for selector: ${id}`)
    }

    const mode = config?.mode ?? target.getAttribute('data-mode') ?? 'default'

    const domain = config?.domain ?? target.getAttribute('data-domain') ?? ''

    const allowStripe = config?.allowStripe
      ?? target.getAttribute('data-allow-stripe') === 'true'

    mountWidgetMode(mode, {
      target,
      stepsTarget: config?.stepsTarget,
      domain,
      allowStripe,
    })
  }
}

if (window) {
  window.OnwardSearcher = OnwardSearcher
}

declare global {
  interface Window {
    OnwardSearcher: typeof OnwardSearcher
  }
}

export default OnwardSearcher